import { getMessage } from "common/messageUtil"
import { magiContants } from "utils/contants"

// 画面初期表示時
export interface MCAXS211Init {
  collegeCode: string //大学コード
  facultyCode: string //学部コード
  subjectCode: string //学科コード
  subjectClassificationCode: string //学科分類コード
  subjectClassification: string //学科分類
  humanitiesAndSciencesDivisionCode: string //文理区分コード
  humanitiesAndSciencesDivision: string //文理区分
  studentDivision: string //学生区分
}

// "登録する"ボタン押下時
export interface MCAXS211Insert {
  surname: string //姓
  firstName: string //名
  surnameKana: string //姓カナ
  firstNameKana: string //名カナ
  birthday: string //生年月日
  sex: string //性別
  selection: string //選考フロー
  mailAddressPC: string //メールアドレス（メイン）
  mailAddressMobile: string //メールアドレス（サブ）
  phoneNumberMobile: string //電話番号（携帯）
  phoneNumberHome: string //電話番号（自宅）
  phoneNumberVacation: string //電話番号（休暇中）
  postalCode: string //郵便番号
  prefectures: string //都道府県
  addressAfterMunicipalities: string //市区町村以降の住所
  vacPostalCode: string //郵便番号
  vacPrefectures: string //都道府県
  vacAddressAfterMunicipalities: string //市区町村以降の住所
  studentDivision: string //学生区分
  graduationPlanTime: string //卒業予定時期
  schoolName: string //学校名
  universityFaculty: string //学部
  universitySubject: string //学科
  subjectClassification: string //学科分類
  schoolCountryRegion: string //国・地域コード
  schoolState: string //州（アメリカの場合）コード
  degree: string //取得学位
  humanitiesAndSciencesDivision: string //文理区分
  zeminar: string //ゼミ
  circle: string //サークル
  majorTheme: string //専攻テーマ
  ownedQualificationTag: string[] //保有資格_タグ
  ownedQualificationSummary: string //保有資格_サマリ
  languageForceTag: string[] //語学スキル_タグ
  languageForceSummary: string //語学スキル_サマリ
  mediaName: string //応募経路コード
  entryDate: string //エントリー日
  selectionFlowSettingId: string //選考フロー設定ID
  collegeCode: string //大学コード
  facultyCode: string //学部コード
  subjectCode: string //学科コード
  schoolGroupCode: string //学校グループコード
  recruitmentManagementDivision: string //採用管理区分
}

// 画面用
export interface MCAXS211Image {
  sameAsCurrentAddress: string //現住所と同じ
  mediaName: string //応募経路
  prefectures: string //現住所都道府県
  vacPrefectures: string //休暇中都道府県
}

// 画面初期表示時
const mcaxs211Init = {
  collegeCode: '', //大学コード
  facultyCode: '', //学部コード
  subjectCode: '', //学科コード
  subjectClassificationCode: '', //学科分類コード
  subjectClassification: '', //学科分類
  humanitiesAndSciencesDivisionCode: '', //文理区分コード
  humanitiesAndSciencesDivision: '', //文理区分
  studentDivision: '', //学生区分
}

// "登録する"ボタン押下時
const mcaxs211Insert = {
  surname: '', //姓
  firstName: '', //名
  surnameKana: '', //姓カナ
  firstNameKana: '', //名カナ
  birthday: '', //生年月日
  sex: '', //性別
  selection: '', //選考フロー
  mailAddressPC: '', //メールアドレス（メイン）
  mailAddressMobile: '', //メールアドレス（サブ）
  phoneNumberMobile: '', //電話番号（携帯）
  phoneNumberHome: '', //電話番号（自宅）
  phoneNumberVacation: '', //電話番号（休暇中）
  postalCode: '', //郵便番号
  prefectures: '', //都道府県
  addressAfterMunicipalities: '', //市区町村以降の住所
  vacPostalCode: '', //郵便番号
  vacPrefectures: '', //都道府県
  vacAddressAfterMunicipalities: '', //市区町村以降の住所
  studentDivision: '', //学生区分
  graduationPlanTime: '', //卒業予定時期
  schoolName: '', //学校名
  universityFaculty: '', //学部
  universitySubject: '', //学科
  subjectClassification: '', //学科分類
  schoolCountryRegion: '', //国・地域コード
  schoolState: '', //州（アメリカの場合）コード
  degree: '', //取得学位
  humanitiesAndSciencesDivision: '', //文理区分
  zeminar: '', //ゼミ
  circle: '', //サークル
  majorTheme: '', //専攻テーマ
  ownedQualificationTag: [], //保有資格_タグ
  ownedQualificationSummary: '', //保有資格_サマリ
  languageForceTag: [], //語学スキル_タグ
  languageForceSummary: '', //語学スキル_サマリ
  mediaName: '', //応募経路コード
  entryDate: '', //エントリー日
  selectionFlowSettingId: '', //選考フロー設定ID
  collegeCode: '', //大学コード
  facultyCode: '', //学部コード
  subjectCode: '', //学科コード
  schoolGroupCode: '', //学校グループコード
  recruitmentManagementDivision: '', //採用管理区分
}

// 画面用
const mcaxs211Image = {
  sameAsCurrentAddress: '', //現住所と同じ
  mediaName: '', //応募経路
  prefectures: '', //現住所都道府県
  vacPrefectures: '', //休暇中都道府県
}

// 年度対応 start
export const listener = (ev: {
  preventDefault: () => void
  returnValue: string
}) => {
  ev.preventDefault()
  ev.returnValue = getMessage(magiContants.MESSAGECODE_MCAXS211_007)
}
// 年度対応 end

export { mcaxs211Init, mcaxs211Insert, mcaxs211Image }
